import { action, makeObservable, observable } from "mobx";
import { RootStore } from "./RootStore";

const sidebarWidth = {
    hidden: 0,
    collapsed: 50,
    expanded: 180,
    expandedMobile: 65
};

export const sidebarWidthUnit = {
    desktop: "px",
    mobile: "%"
};

export enum SIDEBAR_MENU_PATH {
    NONE = "NONE",
    ASSEMBLIES = "ASSEMBLIES",
    OWNERS = "OWNERS",
    MANAGERDASHBOARD = "MANAGERDASHBOARD",
    TICKETS = "TICKETS",
    KREDI_FLOW = "KREDI_FLOW",
    NEW_TICKET = "NEW_TICKET",
    REALESTATES = "REALESTATES",
    SETTINGS = "SETTINGS",
    SETTINGS_CUSTOMERUSERS = "SETTINGS_CUSTOMERUSERS",
    SETTINGS_THEMING = "SETTINGS_THEMING",
    SETTINGS_TILE_ADMINISTRATION = "SETTINGS_TILE_ADMINISTRATION",
    SETTINGS_EASYCONTACT = "SETTINGS_EASYCONTACT",
    SETTINGS_TICKETING = "SETTINGS_TICKETING",
    SETTINGS_KREDI_FLOW = "SETTINGS_KREDI_FLOW",
    SETTINGS_AGENDATEMPLATE = "SETTINGS_AGENDATEMPLATE",
    SETTINGS_PORTAL_DEMO = "SETTINGS_PORTAL_DEMO",
    SETTINGS_USER_FEEDBACK = "SETTINGS_USER_FEEDBACK",
    SERVICES = "SERVICES",
    SERVICES_COSTS_AND_INVOICES = "SERVICES_COSTS_AND_INVOICES",
    SERVICES_FEATURE_AND_INTEGRATION = "SERVICES_FEATURE_AND_INTEGRATION"
}

export class UISidebarStore {
    rootStore: RootStore;
    isSidebarActive: boolean = false;
    isSidebarCollapsed: boolean = false;
    isSidebarLogoDisplayed: boolean = true;
    sidebarWidth: number = sidebarWidth.hidden;
    currentSidebarMenuPath: SIDEBAR_MENU_PATH = SIDEBAR_MENU_PATH.NONE;
    currentSidebarMenuBottomPath: SIDEBAR_MENU_PATH = SIDEBAR_MENU_PATH.NONE;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            isSidebarActive: observable,
            isSidebarCollapsed: observable,
            sidebarWidth: observable,
            currentSidebarMenuPath: observable,
            currentSidebarMenuBottomPath: observable,
            isSidebarLogoDisplayed: observable,

            expandSidebar: action,
            collapseSidebar: action,
            hideSidebar: action,
            setIsSidebarCollapsed: action,
            setIsSidebarActive: action,
            setIsSidebarLogoDisplayed: action,
            setCurrentSidebarMenuPath: action,
            setCurrentSidebarMenuBottomPath: action,
            setSidebarWidth: action
        });
    }

    setSidebarWidth = (sidebarWidth: number) => {
        this.sidebarWidth = sidebarWidth;
    };

    expandSidebar = () => {
        if (this.rootStore.uiStore.isMobile) {
            this.sidebarWidth = sidebarWidth.expandedMobile;
        } else {
            this.sidebarWidth = sidebarWidth.expanded;
        }

        this.isSidebarCollapsed = false;
    };

    collapseSidebar = () => {
        if (this.rootStore.uiStore.isMobile) {
            this.sidebarWidth = sidebarWidth.hidden;
        } else {
            this.sidebarWidth = sidebarWidth.collapsed;
        }

        this.isSidebarCollapsed = true;
    };

    hideSidebar = () => {
        this.sidebarWidth = sidebarWidth.hidden;
    };

    setIsSidebarCollapsed = (isSidebarCollapsed: boolean) => {
        this.isSidebarCollapsed = isSidebarCollapsed;
    };

    setIsSidebarActive = (isSidebarActive: boolean) => {
        this.isSidebarActive = isSidebarActive;
    };

    setCurrentSidebarMenuPath = (currentSidebarMenuPath: SIDEBAR_MENU_PATH) => {
        this.currentSidebarMenuPath = currentSidebarMenuPath;
    };

    setCurrentSidebarMenuBottomPath = (currentSidebarMenuBottomPath: SIDEBAR_MENU_PATH) => {
        this.currentSidebarMenuBottomPath = currentSidebarMenuBottomPath;
    };

    setIsSidebarLogoDisplayed = (isSidebarLogoDisplayed: boolean) => {
        this.isSidebarLogoDisplayed = isSidebarLogoDisplayed;
    };
}
